import { notifications } from '@mantine/notifications';
import * as Sentry from '@sentry/react';

export function notifyError(title: string, error?: unknown, id?: string) {
    console.error(error ?? title);
    if (error !== undefined) Sentry.captureException(error, { extra: { title } });
    notifications.show({
        id,
        color: 'danger',
        title,
        message: error instanceof Error ? error.message : undefined,
        autoClose: 8000,
    });
}
